import creditEngineRepository, { CreditEngineRepository } from './CreditEngineRepository'
import { ContentTypes } from "../../utils/ContentTypes";
import EzUtils from "../../utils/EzUtils";

const resource = "/loanStage";
export default {
  getConsentDetails(officeId, role, officeExternalId) {
    let query = "";
    if (officeId) {
      query = EzUtils.appendQueryParam(query, "officeId", officeId);
    }
    if (role) {
      query = EzUtils.appendQueryParam(query, "role", role);
    }
    if (officeExternalId) {
      query = EzUtils.appendQueryParam(query, "officeExternalId", officeExternalId);
    }

    creditEngineRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return CreditEngineRepository.get(`${resource}/clientDetails/consent${query}`);
  },

  getLoanStageConfigData(loanId, loanStage, role) {
    creditEngineRepository.setContentType(ContentTypes.APPLICATION_JSON);
    const queryParam = role ? `?role=${role}` : "";
    return CreditEngineRepository.get(
      `${resource}/${loanId}/${loanStage}/stageConfig${queryParam}`
    );
  },

  sendLoanStageDetails(request) {
    creditEngineRepository.setContentType(ContentTypes.APPLICATION_JSON);
    return CreditEngineRepository.post(`${resource}/sendDetails`, request);
  }
}
